var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetDeviceInfoAsync as InvokeAsync , GetDeviceInfoSync as InvokeSync}

async function GetDeviceInfoAsync(LoginToken,DeviceUUID)
{
    var GetUserInfoPromise = new Promise((resolve, reject) => {
        GetDeviceInfoSync(LoginToken,DeviceUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetUserInfoPromise;
}

function GetDeviceInfoSync(LoginToken,DeviceUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetDevice',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            DeviceUUID:DeviceUUID ,            
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
